import React, { Component, Fragment } from 'react';
import renderHTML from 'react-render-html';

class Story extends Component {
	render() {
		return (this.props.site_info.story) ? (
			<Fragment>
				<section className="story">
					<h2>Our Story</h2>
					<div className="story-block">{renderHTML(this.props.site_info.story)}</div>
				</section>
			</Fragment>
		) : (
			<Fragment />
		);
	}
}

export default Story;
